import { t, getLang } from "@/lib/i18n";
import { useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useChat = () => {
  const sessionId = useRef(crypto.randomUUID());
  const [messages, setMessages] = useState([]);
  const [busy, setBusy] = useState(false);

  const patchLast = (fn) => setMessages((m) => [...m.slice(0, -1), fn(m[m.length - 1])]);

  const send = async (text, location, onDelta) => {
    if (!text.trim() || busy) return null;
    setBusy(true);
    let full = "";
    let ok = true;
    setMessages((m) => [...m, { role: "user", content: text }, { role: "assistant", content: "", streaming: true }]);
    try {
      const res = await fetch(`${API}/chat/stream`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId.current, message: text, location, lang: getLang() }),
      });
      if (!res.ok) throw new Error("bad status");
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const lines = buf.split("\n\n");
        buf = lines.pop();
        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          const ev = JSON.parse(line.slice(6));
          if (ev.delta) {
            full += ev.delta;
            onDelta?.(full);
            patchLast((l) => ({ ...l, content: l.content + ev.delta }));
          }
          if (ev.error) {
            ok = false;
            patchLast((l) => ({ ...l, content: t("ai.err"), error: true }));
          }
        }
      }
    } catch {
      ok = false;
      patchLast((l) => ({ ...l, content: t("ai.connErr"), error: true }));
    }
    patchLast((l) => ({ ...l, streaming: false }));
    setBusy(false);
    return ok ? full : null;
  };

  const reset = () => {
    sessionId.current = crypto.randomUUID();
    setMessages([]);
  };

  return { messages, busy, send, reset };
};
